import { graphql, useStaticQuery } from "gatsby";
import React from "react";

import BadgeofEthicsSvg from "../../../images/do_good_better_dark.inline.svg";

const ProgramDoGoodBetter = () => {
  const { details } = useStaticQuery(graphql`
    query {
      details: wp {
        ingoPrograms: acfOptionsIngoProgramsConfig {
          ingoPrograms {
            jitDoGoodDesc
          }
        }
      }
    }
  `);

  const { jitDoGoodDesc: do_good_desc } =
    details?.ingoPrograms?.ingoPrograms || {};

  if (do_good_desc?.length < 1) {
    return <></>;
  }

  return (
    <>
      <section className="w-full bg-yellow-lighter min-h-40 grid grid-cols-1 sm:grid-cols-2 gap-x-10 py-10 px-10">
        <div className=" flex sm:justify-center items-center p-4 sm:min-h-40">
          <BadgeofEthicsSvg className="h-full w-full" />
        </div>
        <div className="flex justify-center items-center p-4">
          <div
            className="do-good-better-desc"
            dangerouslySetInnerHTML={{
              __html: do_good_desc || ""
            }}
          ></div>
        </div>
      </section>
    </>
  );
};

export default ProgramDoGoodBetter;
